import { RootState, _ } from "common";
import { createSelector } from "reselect";

const selectAiBuilder = (state: RootState) => state.AiBuilder;

const selectMeta = createSelector(selectAiBuilder, (state) => state.meta);

const selectAiBuilderList = createSelector(
  selectAiBuilder,
  (state) => state.AIBuilderList
);

const selectIsLastPage = createSelector(
  selectAiBuilder,
  (state) => state.isLastPage
);

export const selectors = {
  selectMeta,
  selectAiBuilderList,
  selectIsLastPage,
};
